import { useMemo } from 'react';
import { getCookie } from '@/utils/cookies';
import { useGetClientQuery } from '@/queries/useGetClientQuery';

export const useAvatarProfile = () => {
  const userToken: string | null = getCookie('user_token');

  const { data: clientData, isPending, error } = useGetClientQuery();

  const firstLetter: string = useMemo(() => {
    if (clientData) return `${clientData.name.charAt(0).toUpperCase()}`;
    return '';
  }, [clientData]);

  if (isPending)
    return {
      firstLetter: 'Г',
    };

  if (error)
    return {
      firstLetter: 'X',
    };
  return {
    firstLetter,
  };
};
